module.exports = __webpack_public_path__ + "resources/img/img_text_to_speech2.d95e177604dfd648e8a5867a0459c63c.png";